/* global APPCUES_ENV */

import React, { useEffect } from "react";

let cache = {};

// NOTE: While unlikely in practice, directly using object prototype methods can
//       result in subtle bugs from `Object.create` and shadowing built-ins. The
//       following is the recommended way by eslint and airbnb to check for a
//       key on an object. https://eslint.org/docs/rules/no-prototype-builtins
const { hasOwnProperty } = Object.prototype;

export const flushWarningsCache = () => {
  cache = {};
};

export const withDeprecation = (WrappedComponent, ...message) => {
  if (APPCUES_ENV === "prod") {
    return WrappedComponent;
  }

  const { displayName, name } = WrappedComponent;
  const componentName = displayName || name || "Component";

  const Deprecated = props => {
    useEffect(() => {
      if (!hasOwnProperty.call(cache, componentName)) {
        console.warn(`[deprecation]`, ...message);
        cache[componentName] = message;
      }
    }, []);

    return <WrappedComponent {...props} />;
  };

  Deprecated.displayName = `Deprecated(${componentName})`;

  return Deprecated;
};
